import { render, staticRenderFns } from "./DomainList.vue?vue&type=template&id=d6aa1d8c&scoped=true"
import script from "./DomainList.vue?vue&type=script&lang=js"
export * from "./DomainList.vue?vue&type=script&lang=js"
import style0 from "./DomainList.vue?vue&type=style&index=0&id=d6aa1d8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6aa1d8c",
  null
  
)

export default component.exports